import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'

export function useDeleteSettlement() {
  return useSettlementMutation<string, void>({
    toastKey: 'settlementDeleted',
    request: async (id) => {
      await apiClient.delete(`${settlementsUrl}/${id}`)
    }
  })
}
